import axios from 'axios'
import * as restfulService from './restfulService'
import bus from '@utils/bus'

export default {
  get (domains) {
    // Lista de requisições que serão executadas
    const promises = []
    // Lista de respostas das requisições
    const responses = {}

    if (domains !== undefined && domains.length > 0) {
      bus.$emit('show-loader')
      // Percorre a lista de domains solicitada
      domains.forEach(function (val) {
        if (val !== undefined) {
          val.route = val.route || null
          let defaultData = {
            orderBy: [
              {
                column: 'descricao',
                direction: 'ASC'
              }
            ]
          }
          let data = val.data || defaultData
          switch (val.domain) {

            case 'necessidade_especial':
              if (!data.orderBy) {
                data.orderBy = defaultData.orderBy
              }
              promises.push(restfulService.search('necessidade_especial', val.route, data, null, null, 1, 2000))
              responses.necessidades_especiais = []
              break

            case 'grau_instrucao':
              if (!data.orderBy) {
                data.orderBy = defaultData.orderBy
              }
              promises.push(restfulService.search('grau_instrucao', val.route, data, null, null, 1, 2000))
              responses.grau_instrucoes = []
              break

            case 'area_atuacao':
              if (!data.orderBy) {
                data.orderBy = defaultData.orderBy
              }
              promises.push(restfulService.search('area_atuacao', val.route, data, null, null, 1, 2000))
              responses.areas_atuacao = []
              break

            case 'estado':
              data = {
                ref_pais: 10,
                orderBy: [{column: 'nome', direction: 'ASC'}]
              }
              promises.push(restfulService.search('estado', val.route, data, null, null, 1, 2000))
              responses.estados = []
              break

            case 'mes':
              let meses = []
              for (let i = 1; i <= 12; i++) {
                meses.push(i.toString().padStart(2, '0'))
              }
              promises.push(new Promise(resolve => resolve(meses)))
              responses.meses = []
              break

            case 'ano':
              let anos = []
              for (let i = 1900; i <= new Date().getFullYear(); i++) {
                anos.push(i.toString())
              }
              anos = anos.reverse()
              promises.push(new Promise(resolve => resolve(anos)))
              responses.anos = []
              break

          }
        }
      })
    }

    let loopCounter = 0

    /**
     * Realiza todas as requisições e atribui os resultados ao objeto respose
     * @type {Promise<any>}
     */
    const data = axios.all(promises)
      .then((result) => {
        for (let index in responses) {
          if (result[loopCounter] !== undefined) {
            if (result[loopCounter].data !== undefined) {
              responses[index] = result[loopCounter].data
            } else {
              responses[index] = result[loopCounter]
            }
          } else {
            responses[index] = []
          }
          loopCounter++
        }
        return responses
      })

    /**
     * Retorna uma nova Promisse com o resultado das requisições
     * Exemplo de retorno:
     * {
     *      clientes: [],
     *      produtos: []
     *  }
     */
    return new Promise((resolve) => {
      resolve(data)
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/services/dataService.js